import script from "./ysxy.vue?vue&type=script&lang=ts&setup=true"
export * from "./ysxy.vue?vue&type=script&lang=ts&setup=true"

import "./ysxy.vue?vue&type=style&index=0&id=36ac61f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ac61f6"]])

export default __exports__